export enum Paths {
  Default = '/',
  Root = '/',

  Login = '/login',
  Logout = '/logout',
  Registration = '/registration',
  RegistrationComplete = '/registrationComplete',
  RegistrationByInvite = '/invite/:code',
  PrivateRegistration = '/privateRegistration/:code',
  ApprovePrivateRegistration = '/approvePrivateRegistration/:code',
  RegistrationRequest = '/registrationRequest', // with landing settings registrations
  RegistrationRequestComplete = '/registrationRequestComplete', // with landing settings registrations
  RegistrationByInvitation = '/registrationByInvitation/:code',

  EmailVerification = '/emailVerification/:code',
  EmailVerificationComplete = '/emailVerificationComplete',

  ForgotPassword = '/forgotPassword',
  ResetPasswordRedirect = '/resetPassword/:code/:email',
  ResetPasswordNonAuth = '/reset-password-direct/:code/:email',
  RecoveryPassword = '/recovery-password/:code/:email',

  Onboarding = '/onboarding/:page?/:subpage?/:screenType?',
  QuickOnboarding = '/quickOnboarding',

  Workspace = '/:workspaceId',

  Chat = '/:workspaceId/chat',
  ChatFull = '/:workspaceId/chat/:channelId?/:chatId?/:messageId?',
  Channel = '/:workspaceId/chat/:channelId',
  SpecificChat = '/:workspaceId/chat/:channelId/:chatId',
  SpecificMessage = '/:workspaceId/chat/:channelId/:chatId/:messageId',
  UserChat = '/:workspaceId/user/:channelId?/:userId?',

  Settings = '/:workspaceId/settings/:page/:channelType?/:channelScreenType?',

  ResetPasswordProfile = '/settings-reset-password/:code/:email',
  PersonalInfo = '/:workspaceId/settings/profile',
  Channels = '/:workspaceId/settings/channels/:channelType?/:channelScreenType?',
  Snippets = '/:workspaceId/settings/snippets',
  Tags = '/:workspaceId/settings/tags',
  WorkspaceMembers = '/:workspaceId/settings/members',
  WorkspaceSettings = '/:workspaceId/settings/workspace',

  ChannelsInstagramCallback = '/channels/instagram/auth-callback',

  Billing = '/:workspaceId/settings/billing',
  BillingPaySuccess = '/:workspaceId/settings/billing/pay-success/stripe/:tariffId',
  BillingPayCancel = '/:workspaceId/settings/billing/pay-cancel/stripe/:tariffId',
  BillingTariff = '/:workspaceId/settings/billing/tariff/:tariffId',

  RawBillingTariff = '/settings/billing/tariff/:tariffId',

  SettingsMenu = '/:workspaceId/settings',
  ChannelsMenu = '/:workspaceId/channels',
  TeamMenu = '/:workspaceId/team',
  ActivitiesMenu = '/:workspaceId/activities',

  BlockedWorkspaceAccess = '/blockedWorkspaceAccess',
  AcceptInvite = '/acceptInvite',
  ExpiredInvite = '/expiredInvite',

  WidgetApiDocs = '/widget-api-docs',

  StarterPage = '/starter',
}

export default Paths;

export type WorkspacePathType =
  | Paths.PersonalInfo
  | Paths.Channels
  | Paths.WorkspaceMembers
  | Paths.Snippets
  | Paths.Billing
  | Paths.BillingPayCancel
  | Paths.BillingPaySuccess
  | Paths.Tags
  | Paths.WorkspaceSettings
  | Paths.Chat
  | Paths.SettingsMenu
  | Paths.ChannelsMenu
  | Paths.TeamMenu
  | Paths.ActivitiesMenu
  ;

export type WorkspacePathParams = {
  workspaceId?: string;
  code?: string;
  messageId?: string | null;
  chatId?: string | null;
  channelId?: string | null;
  channelType?: string;
  channelScreenType?: string;
  subpage?: string;
  screenType?: string;
  tariffId?: string;
  userId?: string;
  email?: string;
};

export interface UserChatRouteParams {
  workspaceId?: string;
  channelId?: string;
  chatId?: string;
  userId?: string;
  messageId?: string;
  avatarId?: string;
}